/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// Data
import dataTableData from "layouts/management/notice/list/data/dataTableData";
import { NoticeService } from "service/notice/service";
import { useNavigate } from "react-router-dom";

// 탭 정의: label(화면 표시) + type(백엔드 bcode). 실제 코드에 맞게 type 값만 조정하세요.
const NOTICE_TABS = [
  { key: "notice", label: "공지사항", type: "A" },
  { key: "secret", label: "비밀게시글", type: "E" },
];

function NoticeList(): JSX.Element {
  const [activeTab, setActiveTab] = useState(NOTICE_TABS[0].key);
  const [limit, setlimit] = useState(10);
  const [page, setPage] = useState(0);
  const [tabledata, settabledata] = useState(dataTableData());
  const [totalcount, settotalcount] = useState(0);
  const [open, setOpen] = useState(false);
  const [signdata, setsigndata] = useState({
    paymentIdx: "",
    amount: "",
    method: "",
    depositor: "",
    isValid: "",
    description: "",
    paymentTime: "",
    email: "",
  });

  const navigate = useNavigate();

  const currentType = NOTICE_TABS.find((t) => t.key === activeTab)?.type ?? "A";

  const list = async () => {
    try {
      const res = await NoticeService.list(currentType, "", limit, page * limit);
      // 배포 백엔드는 최상위로 내려주고(res.list), 일부는 {data:{list}}로 감쌈 → 둘 다 대응
      const payload = res?.list ? res : res?.data ?? {};
      const rows = payload.list ?? [];
      // 결과가 0건이어도 항상 갱신해야 이전 탭의 목록/페이지 수가 남지 않음
      settabledata(
        dataTableData(
          rows.map((el: any) => {
            return {
              category: el.category,
              writeTime: el.write_time,
              title: el.title,
              isImportant: el.is_important,
              views: el.views,
              articleIdx: el.articleidx,
              articleIdx2: el.articleidx,
              articleIdx3: el.articleidx,
            };
          }),
          view,
          deletefunc,
          currentType
        )
      );
      settotalcount(Number(payload.total_count ?? payload.totalCount ?? 0));
    } catch (err) {
      console.log(err);
    }
  };

  const view = async (idx: string) => {
    try {
      navigate("/management/notice/notice-update/" + idx);
    } catch (err) {
      console.log(err);
    }
  };

  const deletefunc = async (idx: string) => {
    try {
      await NoticeService.delete(idx);
      list();
    } catch (err) {
      console.log(err);
    }
  };

  const openSign = () => {
    setsigndata({
      paymentIdx: "",
      amount: "",
      method: "",
      depositor: "",
      isValid: "",
      description: "",
      paymentTime: "",
      email: "",
      // agriculturalNum: "",
    });
    setOpen(true);
  };

  useEffect(() => {
    list();
  }, [page, activeTab]);

  const handleTabChange = (key: string) => {
    if (key === activeTab) return;
    setPage(0);
    const nextType = NOTICE_TABS.find((t) => t.key === key)?.type ?? "A";
    settabledata(dataTableData([], view, deletefunc, nextType)); // 이전 탭 데이터 잔상 제거(빈 목록)
    settotalcount(0);
    setActiveTab(key);
  };

  return (
    <DashboardLayout>
      {/* {modal1(open, setOpen, signdata, onChange, setsigndata, create)}
      {modal2(open2, setOpen2, updatedata, onChange2, setupdatedata, update)} */}
      <DashboardNavbar />
      <MDBox my={3}>
        <MDBox display="flex" gap={1} mb={2}>
          {NOTICE_TABS.map((t) => {
            const active = t.key === activeTab;
            return (
              <MDBox
                key={t.key}
                component="button"
                type="button"
                onClick={() => handleTabChange(t.key)}
                sx={{
                  border: "none",
                  cursor: "pointer",
                  px: 2.5,
                  py: 1,
                  borderRadius: 2,
                  fontSize: 14,
                  fontWeight: active ? 700 : 500,
                  color: active ? "#fff" : "text.secondary",
                  backgroundColor: active ? "info.main" : "grey.200",
                }}
              >
                {t.label}
              </MDBox>
            );
          })}
        </MDBox>
        <Card>
          <DataTable
            key={activeTab}
            table={tabledata}
            entriesPerPage={false}
            canSearch
            isSorted={false}
            totalCount={totalcount}
            setPage={setPage}
            page2={page}
            pagination={{ variant: "gradient", color: "dark" }}
          />
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default NoticeList;
